export function last(array) { return array[array.length - 1]; }
export function unique(array) { return array.filter((x, index) => array.indexOf(x) === index); }
